var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 8.33341H15.8333C17.5 8.33341 18.3333 7.50008 18.3333 5.83341V4.16675C18.3333 2.50008 17.5 1.66675 15.8333 1.66675H14.1667C12.5 1.66675 11.6667 2.50008 11.6667 4.16675V5.83341C11.6667 7.50008 12.5 8.33341 14.1667 8.33341Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16666 18.3334H5.83332C7.49999 18.3334 8.33332 17.5001 8.33332 15.8334V14.1667C8.33332 12.5001 7.49999 11.6667 5.83332 11.6667H4.16666C2.49999 11.6667 1.66666 12.5001 1.66666 14.1667V15.8334C1.66666 17.5001 2.49999 18.3334 4.16666 18.3334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M4.99999 8.33341C6.84094 8.33341 8.33332 6.84103 8.33332 5.00008C8.33332 3.15913 6.84094 1.66675 4.99999 1.66675C3.15904 1.66675 1.66666 3.15913 1.66666 5.00008C1.66666 6.84103 3.15904 8.33341 4.99999 8.33341Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M15 18.3334C16.8409 18.3334 18.3333 16.841 18.3333 15.0001C18.3333 13.1591 16.8409 11.6667 15 11.6667C13.159 11.6667 11.6667 13.1591 11.6667 15.0001C11.6667 16.841 13.159 18.3334 15 18.3334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.99c93669489204777aa9eef77a4214ab.svg";
export { ForwardRef as ReactComponent };